import { default as OLImageWMSSource } from 'ol/source/ImageWMS';

import type { Options } from 'ol/source/ImageWMS';

// Create a public getter & setters to avoid accessing private properties from our code
export class ImageWMSSource extends OLImageWMSSource {

  #ratio;
  #url;

  constructor (options?: Options) {
    super(options);
    this.#ratio = options?.ratio ?? 1.5; // 1.5 is the default value in OL
    this.#url = options?.url;
  }

  /**
   * There is NO SETTER for the ratio on purpose.
   * We don't want to use private OL properties like ratio_ and this property has no setter in the parent class.
   * So if you need to change the ratio of a source, please reinitialize the source with the new ratio
   * and set it on the layer.
   */
  getRatio () {
    return this.#ratio;
  }

  override setUrl (url?: string, silent = false) {
    this.#url = url;
    if (!silent) {
      super.setUrl(url);
    }
  }

  override getUrl () {
    return this.#url;
  }

}
